import { toRefs } from 'vue'
import { storeToRefs } from 'pinia'
import type { RouteLocationNormalized } from 'vue-router'

import { useProjectCreationStore } from '~/portal/stores'

export const certificationMiddleWare = async (
	_: RouteLocationNormalized,
	__: RouteLocationNormalized
) => {
	const projectStore = useProjectCreationStore()
	const { powerPlantAddress, applicantInformation } = storeToRefs(projectStore)
	const { applicant } = toRefs(applicantInformation.value)

	const isEmptyApplicant = Object.values(applicant.value).some((value) => !!value)
	const isEmptyPowerPlantAddress = Object.values(powerPlantAddress.value).some((value) => !!value)

	if (!isEmptyApplicant && !isEmptyPowerPlantAddress) {
		return 'project-creation'
	}
}
